import { fg } from '@atlassian/jira-feature-gating';

const FixAiEnablementChecksInIssueViewRelayProvider = {
	get(): boolean {
		return fg('fix_ai_enablement_checks_in_issue_view');
	},
};

export default FixAiEnablementChecksInIssueViewRelayProvider;
